import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=251f2864&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=251f2864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f2864",
  null
  
)

export default component.exports